import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import FavouritedPack from './FavouritedPack';
import { Link } from "react-router-dom"

@inject('favouritedPacksStore')
@observer
class FavouritedPacksSidebar extends Component {
  componentDidMount() {
    const { favouritedPacksStore } = this.props;
    favouritedPacksStore.fetchUserFavourites(1);
  }

  componentWillUnmount() {
    const { favouritedPacksStore } = this.props;
    favouritedPacksStore.reset();
  }

  renderPacks() {
    const { favouritedPacksStore } = this.props;
    return favouritedPacksStore.favs.slice(0, 10).map((pack, i) => <FavouritedPack key={i} pack={pack} />)
  }

  noPacksInfo = (loaded = false) => (
    <div className='pt-3.5 pb-5 text-center w-full'>
      { loaded ? "No Favourite Packs" : "Loading..." }
    </div>
  )

  render() {
    const { favouritedPacksStore } = this.props;
    const favsLength = favouritedPacksStore.favs.length

    if (favsLength <= 0) {
      return this.noPacksInfo(favouritedPacksStore.loaded)
    }

    return (
      <div className='flex flex-col mb-12'>
        {
          favsLength > 0 && this.renderPacks()
        }
        {
          favsLength > 10 && (
            <Link
              to='/products-favourited'
              className='cursor-pointer text-center pt-4 pb-5'
            >
              Load more
            </Link>
          )
        }
      </div>
    )
  }
}

export default FavouritedPacksSidebar;
